(() => {
  'use strict';
  const init = () => {
    const ar = document.documentElement.lang.toLowerCase().startsWith('ar');
    const parseDeadline = s => { if(!s || !/([zZ]|[+-]\d\d:\d\d)$/.test(s)) return NaN; const x=Date.parse(s); return Number.isFinite(x)?x:NaN; };
    const pad = n=>String(n).padStart(2,'0');
    function runTimer(el, text, deadline){
      if(!el || !text || !Number.isFinite(deadline)) return;
      const step=()=>{
        const remaining=deadline-Date.now();
        if(remaining<=0){el.hidden=true;return false;}
        el.hidden=false;
        const seconds=Math.floor(remaining/1000);
        const days=Math.floor(seconds/86400);
        const h=Math.floor(seconds%86400/3600);
        const m=Math.floor(seconds%3600/60);
        const s=seconds%60;
        text.textContent=(days?days+(ar?' يوم ':'d '):'')+pad(h)+':'+pad(m)+':'+pad(s);
        return true;
      };
      if(step()){const interval=setInterval(()=>{if(!el.isConnected || !step()) clearInterval(interval);},1000);}
    }
    document.querySelectorAll('[data-cro-offer]:not([data-cro-ready])').forEach(el=>{
      el.dataset.croReady='1';
      runTimer(el,el.querySelector('[data-cro-offer-clock]'),parseDeadline(el.dataset.ends));
    });
    document.querySelectorAll('[data-cro-session]:not([data-cro-ready])').forEach(el=>{
      el.dataset.croReady='1';
      const deadline=parseDeadline(el.dataset.ends);
      if(!Number.isFinite(deadline) || deadline<=Date.now())return;
      el.hidden=false;
      el.querySelector('[data-cro-reveal]')?.addEventListener('click',event=>{
        event.currentTarget.hidden=true;
        const link=el.querySelector('[data-cro-session-link]');
        if(link) link.hidden=false;
      });
      const delay=deadline-Date.now();
      setTimeout(()=>{if(el.isConnected)el.hidden=true;},Math.min(delay,2147483647));
    });
    const cutoffTime = () => {
      try{
        const parts=new Intl.DateTimeFormat('en-GB',{timeZone:'Africa/Cairo',weekday:'short',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
        const get=type=>parts.find(p=>p.type===type)?.value||'';
        return {day:get('weekday'),hour:Number(get('hour')),minute:Number(get('minute'))};
      }catch(e){return null;}
    };
    document.querySelectorAll('[data-cro-cutoff]:not([data-cro-ready])').forEach(el=>{
      el.dataset.croReady='1';
      const match=/^([01]?\d|2[0-3]):([0-5]\d)$/.exec(el.dataset.cutoff||'');
      if(!match)return;
      const hour=Number(match[1]),min=Number(match[2]);
      const target=hour*60+min;
      const step=()=>{
        const now=cutoffTime();
        if(!now || !['Sat','Sun','Mon','Tue','Wed'].includes(now.day)){el.hidden=true;return;}
        const remain=target-(now.hour*60+now.minute);
        if(remain<=0){el.hidden=true;return;}
        el.hidden=false;
        const clock=el.querySelector('[data-cro-cutoff-clock]');
        if(clock)clock.textContent=(ar?'متبقي ':'Left ')+Math.floor(remain/60)+(ar?' س ':'h ')+pad(remain%60)+(ar?' د':'m');
      };
      step();
      const interval=setInterval(()=>{if(!el.isConnected)clearInterval(interval);else step();},60000);
    });
    document.querySelectorAll('[data-cro-routine]:not([data-cro-ready])').forEach(el=>{
      el.dataset.croReady='1';
      const days=Number(el.dataset.days)||0;
      const result=el.querySelector('[data-cro-routine-result]');
      const buttons=[...el.querySelectorAll('[data-cro-packs]')];
      let highestPack=Math.max(1,...buttons.map(b=>Number(b.dataset.croPacks)||1));
      const showPacks=limit=>{
        highestPack=Math.max(1,Math.min(buttons.length,Number(limit)||highestPack));
        buttons.forEach(b=>{b.hidden=Number(b.dataset.croPacks)>highestPack;});
        const selected=buttons.find(b=>b.getAttribute('aria-pressed')==='true');
        if(selected && selected.hidden)buttons[0]?.click();
      };
      buttons.forEach(button=>button.addEventListener('click',()=>{
        const packs=Math.max(1,Math.min(highestPack,Number(button.dataset.croPacks)||1));
        buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        if(result)result.textContent=ar
          ? (packs===1?'عبوة واحدة':packs===2?'عبوتين':packs+' عبوات')+' تكفي تقريبًا '+(packs*days)+' يوم حسب الجرعة المذكورة.'
          : packs+' '+(packs===1?'pack':'packs')+' cover approximately '+(packs*days)+' days at the stated daily directions.';
      }));
      // Match the top pack-count tier in the existing product pricing file.
      // Never calculate or promise a discount here: the purchase widget remains the authority.
      if(el.dataset.pricingUrl && el.dataset.productId){
        fetch(el.dataset.pricingUrl,{credentials:'omit'})
          .then(response=>{if(!response.ok)throw Error('pricing unavailable');return response.json();})
          .then(pricing=>{
            const rules=pricing?.products?.[el.dataset.productId]?.rules;
            if(!Array.isArray(rules)||!rules.length)return;
            const tiers=rules.map(r=>Number(r.min)).filter(n=>Number.isFinite(n)&&n>=1);
            if(tiers.length)showPacks(Math.max(...tiers));
          })
          .catch(()=>{}); // Keep the five supported choices if the optional pricing lookup is unavailable.
      }
    });
    document.querySelectorAll('[data-zyma-savings-progress]:not([data-cro-ready])').forEach(el=>{
      el.dataset.croReady='1';
      const root=el.closest('[data-zyma-bundle-builder]');
      if(!root)return;
      const countElement=root.querySelector('[data-builder-count]');
      const savingElement=root.querySelector('[data-builder-saving]');
      const amount=el.querySelector('[data-cro-saving-amount]');
      const steps=[...el.querySelectorAll('[data-cro-step]')];
      let pending=false;
      const update=()=>{
        pending=false;
        const count=Math.min(3,Math.max(0,Number(countElement?.textContent)||0));
        steps.forEach((step,i)=>step.classList.toggle('is-on',count>=i+1));
        const saving=savingElement?.textContent?.trim()||'';
        if(amount)amount.textContent=count<2
          ?(ar?'ضيف عبوتين عشان يبدأ التوفير':'Choose two packs to start saving')
          :(ar?'توفيرك المتوقع دلوقتي: ':'Estimated savings now: ')+saving+(ar?' — النهائي بيتأكد في السلة':' — confirmed in cart');
      };
      const schedule=()=>{if(!pending){pending=true;queueMicrotask(update)}};
      if(countElement)new MutationObserver(schedule).observe(countElement,{childList:true,characterData:true,subtree:true});
      if(savingElement)new MutationObserver(schedule).observe(savingElement,{childList:true,characterData:true,subtree:true});
      update();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();